import type { WorkflowDefinition } from "../types";

export const campaignBriefTextWorkflow: WorkflowDefinition = {
  id: "campaign-brief-text",
  family: "text-content",
  steps: [
    "content_validation",
    "language_clarity_review",
    "voice_review",
    "approval_gate",
  ],
};
